import { useEffect } from 'react';
import './Modal.css';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';

interface ModalProps {
  isOpen?: boolean;
  onClose: () => void;
  withCloseButton?: boolean;
  children: React.ReactNode;
}

const Modal = ({ isOpen, onClose, withCloseButton, children }: ModalProps) => {
  // useEffect to handle keyboard events for accessibility
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  // If the modal is not open, don't render anything
  if (!isOpen) {
    return null;
  }

  return (
    // Modal backdrop - closes the modal when clicked
    <div className="custom-modal-backdrop" onClick={onClose}>
      {/* Modal container - prevents closure when clicking inside */}
      <div
        className="custom-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button row */}
        {withCloseButton && (
          <div className="custom-modal-header">
            <button onClick={onClose} className="custom-modal-close-button">
              <CloseIcon />
            </button>
          </div>
        )}

        {/* Modal content */}
        <div className="custom-modal-content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
